import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDatastaxComponent } from './simple-icons-datastax.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDatastaxComponent ],
    exports:      [ SimpleIconsDatastaxComponent ],
    bootstrap:    []
})
export class SimpleIconsDatastaxModule {}
